import React, { FunctionComponent } from "react";

import { NoDataTile, Separator, Stack } from "@bps/fluent-ui";
import { withPermissions } from "@components/withPermissions";
import { PltUser } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { BpIdUserAuditLogList } from "../../../../../system/sections/plt/bpid/components/BpIdUserAuditLogList";
import { BpIdAuditLogsFilter } from "./BpIdAuditLogsFilter";

interface UserSignInLogsProps {
  user: PltUser;
}
export const UserSignInLogsBase: FunctionComponent<UserSignInLogsProps> = props => {
  return (
    <Stack>
      <Separator />
      {props.user.bpIdUserId ? (
        <Stack>
          <BpIdAuditLogsFilter>
            {({ values }) => (
              <BpIdUserAuditLogList
                bpIdUserId={props.user.bpIdUserId!}
                filters={values}
              />
            )}
          </BpIdAuditLogsFilter>
        </Stack>
      ) : (
        <NoDataTile
          styles={{ root: { flexGrow: 1 } }}
          textProps={{ text: "User does not have Bp Id account" }}
          linkProps={{}}
          showBoxShadow={false}
        />
      )}
    </Stack>
  );
};

export const UserSignInLogs = withPermissions(
  UserSignInLogsBase,
  [Permissions.PltBpidAuditRead],
  "or"
);
